var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('ItemTextInfo',[_c('v-row',[_c('v-col',[_vm._v(" Total Item: "+_vm._s(this.countItemRelease)+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }